import { Record } from "immutable";
import { EnhancedContentManifest } from "models/interfaces/enhanced-content-manifest";

const defaultValues: EnhancedContentManifest = {
    id: 0,
    externalId: "",
};

export default class EnhancedContentManifestRecord
    extends Record(defaultValues)
    implements EnhancedContentManifest
{
    constructor(params?: EnhancedContentManifest) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }
        super(params);
    }

    public getHtmlId(): string {
        return `${this.id}-${this.externalId}`;
    }
}
